import Axios from "../../axios";
import { ApiCommonParams } from "../../@types/apiTypes";
import { ApiResponse } from "../../apiResponse";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexStudentNotes(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/students/notes`, { params: params });
}
